import mergeDocumentData from "../../utils/mergeDocumentData";
import runTransaction from "../../utils/runTransaction";
import updateDocumentData from "../../utils/updateDocumentData";

import transformWorkProductionData from "../works/data/transformWorkProductionData";

import { Production } from "./types/Production";

export default function updateProduction(firebase, data, { articles, transaction, partial = true } = {}) {
	const db = firebase.firestore();

	const producerId = data.producer?.id || data.producer;
	const publisherId = data.publisher?.id || data.publisher;

	const producerRef = producerId && db.collection("organizations").doc(producerId);
	const publisherRef = publisherId && db.collection("organizations").doc(publisherId);

	if (data.work) {
		data = {
			...data,
			...transformWorkProductionData(data.work),
		};
	}

	if (articles) {
		data.articleIds = articles.map(({ id }) => id);
		data.articles = articles.reduce(
			(acc, article) => ({ ...acc, [article.id]: { ...data.articles?.[article.id], type: article.type } }),
			{},
		);
	}

	if (data.publisherManagers) {
		data.publisherManagerIds = data.publisherManagers?.map(({ id }) => id);
	}

	return runTransaction(
		firebase,
		[data.ref, producerRef, publisherRef],
		async (transaction, [production, producer, publisher]) => {
			if (producer?.name) {
				data.producer = producer.id;
				data.producerName = producer.name;
			}

			if (publisher?.name) {
				data.publisher = publisher.id;
				data.publisherName = publisher.name;
			}

			if (data.comment?.id) {
				transaction.set(production.ref.collection("comments").doc(data.comment.id), {
					...data.comment,
					time: firebase.firestore.FieldValue.serverTimestamp(),
				});
			}

			data = (partial ? Production.partial() : Production).parse(updateDocumentData(firebase, data));

			if (publisher?.featureFlags?.includes("discussion")) {
				data.useNewDiscussion = true;
			}

			transaction.set(production.ref, data, { merge: true });

			return mergeDocumentData(production, { ...data, exists: true });
		},
		transaction,
	);
}
